<h2 mat-dialog-title class="dialog-title">Gebäude bearbeiten</h2>
<mat-dialog-content class="mat-typography dialog-content">
  <form [formGroup]="frmGebaeude">
    <!-- Standort dropdown (only for superuser/companyadmin) -->
    <div class="form-group" *ngIf="canMoveGebaeude()">
      <label class="form-label" for="standort_id">Standort</label>
      <select 
        class="form-control" 
        id="standort_id" 
        formControlName="standort_id"
        [disabled]="isLoadingStandorte">
        <option value="">Standort auswählen...</option>
        <option *ngFor="let standort of standorte" [value]="standort.id">
          {{ standort.name }} ({{ standort.nummer }})
        </option>
      </select>
      <small class="form-text text-muted" *ngIf="currentStandortName">
        Aktuell: {{ currentStandortName }}
      </small>
      <div *ngIf="isLoadingStandorte" class="text-muted small mt-1">
        Lade Standorte...
      </div>
    </div>
    
    <!-- Hidden input for non-admin users (backward compatibility) -->
    <div class="form-group" *ngIf="!canMoveGebaeude()">
      <input type="hidden" formControlName="standort_id" />
    </div>
    
    <div class="form-group">
      <label class="form-label" for="name">Gebäude Name</label>
      <input type="text" class="form-control" id="name" formControlName="name" placeholder="Gebäude Name eingeben" />
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button *ngIf="isInactive()" (click)="onRestore()">Wiederherstellen</button>
  <button mat-button *ngIf="!isInactive()" color="warn" (click)="onDelete()">Löschen</button>
  <button mat-button (click)="onDismiss()">Abbrechen</button>
  <button mat-button (click)="onConfirm()" cdkFocusInitial>Speichern</button>
</mat-dialog-actions>

